// extracted by mini-css-extract-plugin
module.exports = {"article":"Article-module--article--3w0mH","content":"Article-module--content--3UZCw","aside":"Article-module--aside--17mku","isLeftAligned":"Article-module--isLeftAligned--2tX4_"};